// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c4aef51f","113":"a62deed7","453":"2993c946","671":"062e39c4","805":"a265ff14","893":"9c8e6061"}[chunkId] + ".chunk.js";
};